var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.2272 4.29894L27.2669 16.3387V28.9341H3.18746V16.3387L15.2272 4.29894ZM15.2272 0.40918L0.409058 15.2273V31.7125H30.0453V15.2273L15.2272 0.40918Z","fill":"#34363E","key":0}),React.createElement("path",{"d":"M18.5614 18.3762H11.8932V29.8603H18.5614V18.3762Z","fill":"#34363E","key":1})]);
}

Home.defaultProps = {"width":"31","height":"32","viewBox":"0 0 31 32","fill":"none"};

module.exports = Home;

Home.default = Home;
